import { useTranslation } from 'react-i18next'
import { Box, Image, Text, Flex, useMediaQuery} from '@chakra-ui/react'
import EmptyFolderImage from '@core/assets/images/empty_folder.svg'

const EmptyState = () => {
    const { t } = useTranslation()

    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })

    return (
        <Flex 
            justifyContent={'center'} 
            mt={!isDesktop ? '40px' : '80px'} 
            mb={!isDesktop ? '40px' : '60px'}
        >
            <Box textAlign={'center'}>
                <Image src={EmptyFolderImage} mx={'auto'} alt={`${t('5190')}`} />
                <Text fontSize={'20px'} fontWeight={'600'} mt={'25px'} mb={'10px'}>{t('7843')}</Text>
                <Text fontSize={'14px'} fontWeight={'500'} color={'text.secondary'}>{t('7844')}.</Text>
                <Text fontSize={'14px'} fontWeight={'500'} color={'text.secondary'} mt={'3px'}>{t('7845')}.</Text>
            </Box>
        </Flex>
    )
}

export default EmptyState